<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('checklist.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links">
        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('sidebar.dashboard'),
            path: '/financial/dashboard',
            icon: 'tim-icons icon-chart-pie-36'
          }"
        ></sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('financial.global.sales'),
            icon: 'tim-icons icon-coins'
          }"
        >
          <sidebar-item
            :link="{
              name: $t('financial.global.sale'),
              path: '/financial/sales/list',
              icon: 'tim-icons icon-upload'
            }"
          />
          <sidebar-item
            :link="{
              name: $t('financial.global.estimate'),
              path: '/financial/sales/estimate',
              icon: 'tim-icons icon-upload'
            }"
          />
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('financial.global.purchases'),
            path: '/financial/purchases/list',
            icon: 'tim-icons icon-basket-simple'
          }"
        >
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('sidebar.product'),
            path: '/financial/product/list',
            icon: 'tim-icons icon-app'
          }"
        >
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('sidebar.service'),
            path: '/financial/service/list',
            icon: 'tim-icons icon-laptop'
          }"
        >
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('financial.global.enterprise'),
            path: '/financial/enterprise/list',
            icon: 'tim-icons icon-badge'
          }"
        >
        </sidebar-item>

        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: $t('financial.global.financialAccounts'),
            icon: 'tim-icons icon-bank'
          }"
        >
          <sidebar-item
            :link="{
              name: $t('financial.global.bankAccounts'),
              path: '/financial/bankaccount/list',
              icon: 'tim-icons icon-upload'
            }"
          />
          <sidebar-item
            :link="{
              name: $t('financial.global.banks'),
              path: '/financial/bank/list',
              icon: 'tim-icons icon-upload'
            }"
          />
        </sidebar-item>
        <sidebar-item
          ref="sidebarItemForms"
          :link="{
            name: 'Favoritos',
            icon: 'tim-icons icon-shape-star'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Vendas por vendedor',
              path: '/financial/report/sales',
              icon: 'tim-icons icon-upload'
            }"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="trackingShippingCompany"></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}
import DashboardNavbar from "@/pages/Layout/DashboardNavbar.vue";
import ContentFooter from "src/pages/Layout/SidebarFixedToggleButton.vue";
import SidebarFixedToggleButton from "src/pages/Layout/SidebarFixedToggleButton.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  name: "FinancialLayout",
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackground: "primary",
      isMasterAdmin: false,
      process: []
    };
  },
  created() {
    this.getUserMaster();
    this.getAllProcess();
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isAdministrator;
    },
    isUserViewer() {
      return this.$store.getters.hasAccessUser;
    },
    isProfileViewer() {
      return this.$store.getters.hasAccessProfile;
    },
    isAccessTripPlan() {
      return this.$store.getters.accessTripPlan;
    },
    isCompanyViewer() {
      return this.$store.getters.hasAccessCompany;
    },
    isAccessVehicles() {
      return this.$store.getters.accessVehicles;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then(response => {
          this.isMasterAdmin = response.data;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getAllProcess() {
      this.$apiWorkflow.get("/process/all/").then(response => {
        this.process = response.data;
      });
    },
    getPermission(p) {
      if (p.administrador) return true;
      if (p.gestor) return true;
      if (p.advancedOperator) return true;
      if (p.simpleOperator) return true;
      return false;
    }
  },
  mounted() {
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemSchedules) {
      if (this.$refs.sidebarItemSchedules.collapsed) {
        this.$refs.sidebarItemSchedules.collapseMenu();
      }
    }
  },
  watch: {}
};
</script>

<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>
